var _ = require('underscore');
var $ = require('jquery');
var moment = require('moment');
var TorsoFormView = require('backbone-torso/modules/FormView');
var patientSignupFormTemplate = require('./patientSignupFormTemplate.hbs');
var PatientSignupFormModel = require('./PatientSignupFormModel');
var stringUtils = require('./../utils/stringUtils');
var enumerationListService = require('./../enumeration/enumerationListService');
var formFeatureConfigModel = require('./../form/formFeatureConfigModel');
var PrintableDataBehavior = require('./../printable/PrintableDataBehavior');
var PdfViewerWidget = require('./../widget/pdf-viewer/PdfViewerWidget');
var formExtService = require('./../urls').formExtService;
var patientRegistrationService = require('./patientRegistrationService');
var applicationUtils = require('./../applicationUtils');
var capslockDetectorUtils = require('./../utils/capslockDetectorUtils');

require('pickadate/lib/picker.date.js');

var SECURITY_QUESTIONS_OPTIONS_LIST = 'securityQuestionsOptionList';

/**
 * The PatientSignupFormView is a form view that handles signup.
 *
 * @class PatientSignupFormView
 * @extends Torso.FormView
 */
module.exports = TorsoFormView.extend({
  className: 'brec-form',
  moduleName: 'PatientSignupFormView',
  template: patientSignupFormTemplate,

  prepareFields: {
    currentApplication: applicationUtils.currentApplication,
    securityQuestionsOptionList: function() {
      return enumerationListService.get(SECURITY_QUESTIONS_OPTIONS_LIST);
    },
    showPatientName: function() {
      return this.model.get('authenticated') && !!this.model.get('firstName');
    }
  },

  injectionSites: {
    'privacy-form-pdf-viewer': '_privacyFormPdfViewer',
    'consent-form-pdf-viewer': '_consentFormPdfViewer',
    'additional-form-pdf-viewer': '_additionalFormPdfViewer'
  },

  behaviors: {
    additionalEnrollmentForm: {
      behavior: PrintableDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: {
        property: 'additionalEnrollmentFormVecnaId',
        idContainer: formFeatureConfigModel
      }
    }
  },

  events: {
    'click [data-submit]': '_submit',
    'keyup [data-ssn-input]': '_formatSsn'
  },

  fields: {
    firstName: {
      modelFormat: stringUtils.nullSafeTrimAllUpperCase,
      viewFormat: stringUtils.nullSafeTrimAllUpperCase
    },

    lastName: {
      modelFormat: stringUtils.nullSafeTrimAllUpperCase,
      viewFormat: stringUtils.nullSafeTrimAllUpperCase
    },
    localDob: {
      modelFormat: function (dob) {
        var slashDate = moment(dob, 'MM/DD/YYYY', true);
        return slashDate.isValid() ? slashDate.format('YYYY-MM-DD'): '';
      },

      viewFormat: function (dob) {
        var isoDate = moment(dob, 'YYYY-MM-DD', true);
        return isoDate.isValid() ? isoDate.format('MM/DD/YYYY') : '';
      }
    }
  },

  feedback: [{
    //******** FirstName *********
    /**
     * On keyup or blur on the firstName or submits, validate the firstName
     * @property feedback[0] (FirstName Error Message) {When/Then Feedback}
     */
    when: {
      '@firstName' : ['keyup', 'blur'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('firstName');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'firstNameError'
  }, {
    /**
     * On keyup or blur on the firstName or submits, validate the firstName
     * @property feedback[1] (FirstName Input Field) {When/Then Feedback}
     */
    when: {
      '@firstName' : ['keyup', 'blur'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('firstName', 'brec-form__input--error');
    },
    to: 'firstName'
  }, {
    //******** LastName *********
    /**
     * On keyup or blur on the lastName or submits, validate the lastName
     * @property feedback[2] (LastName Error Message) {When/Then Feedback}
     */
    when: {
      '@lastName' : ['keyup', 'blur'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('lastName');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'lastNameError'
  }, {
    /**
     * On keyup or blur on the lastName or submits, validate the lastName
     * @property feedback[3] (LastName Input Field) {When/Then Feedback}
     */
    when: {
      '@lastName' : ['keyup', 'blur'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('lastName', 'brec-form__input--error');
    },
    to: 'lastName'
  }, {
    //******** Date of Birth *********
    /**
    * On keyup or blur on the localDob or submits, validate the localDob
    * @property feedback[4] (Dob Error Message) {When/Then Feedback}
    */
    when: {
     '@localDob' : ['keyup', 'blur', 'change'],
     'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('localDob');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'dobError'
  }, {
    /**
    * On keyup or blur on the localDob or submits, validate the localDob
    * @property feedback[5] (Dob Input Field) {When/Then Feedback}
    */
    when: {
      '@localDob' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('localDob', 'brec-form__input--error');
    },
    to: 'localDob'
  }, {
    //******** Social Security Number *********
    /**
     * On keyup or blur on the ssn or submits, validate the ssn
     * @property feedback[6] (SSN Error Message) {When/Then Feedback}
     */
    when: {
      '@ssn' : ['keyup', 'blur'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('ssn');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('ssn'), {
          'required.failed': 'patient.signup.ssn.error.required',
          'error.invalid' : 'patient.signup.ssn.error.invalid'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'ssnError'
  }, {
    /**
     * On keyup or blur on the ssn or submits, validate the ssn
     * @property feedback[7] (SSN Input Field) {When/Then Feedback}
     */
    when: {
      '@ssn' : ['keyup', 'blur'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('ssn', 'brec-form__input--error');
    },
    to: 'ssn'
  }, {
   //******** Username *********
   /**
    * On keyup or blur on the username or submits, validate the username
    * @property feedback[8] (Username Error Message) {When/Then Feedback}
    */
   when: {
      '@username' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('username');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('username'), {
          'required.failed': 'patient.signup.username.error.required',
          'error.invalid' : 'patient.signup.username.error.invalid'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'usernameError'
  }, {
    /**
    * On keyup or blur on the username or submits, validate the username
    * @property feedback[9] (Username Input Field) {When/Then Feedback}
    */
    when: {
      '@username' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('username', 'brec-form__input--error');
    },
    to: 'username'
  }, {
   //******** Password *********
   /**
    * On keyup or blur on the newPassword or submits, validate the newPassword
    * @property feedback[10] (Password Error Message) {When/Then Feedback}
    */
    when: {
      '@newPassword' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('newPassword');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('newPassword'), {
          'required.failed': 'patient.signup.password.error.required'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'passwordError'
  }, {
    /**
    * On keyup or blur on the newPassword or submits, validate the newPassword
    * @property feedback[11] (Password Input Field) {When/Then Feedback}
    */
    when: {
      '@newPassword' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('newPassword', 'brec-form__input--error');
    },
    to: 'newPassword'
  }, {
   //******** Password *********
   /**
    * On invalid password event, show error message
    * @property feedback[12] (Password Error Message) {When/Then Feedback}
    */
    when: {
      'on': ['invalidPassword']
    },
    then: function(passwordInvalidReasons) {
      var errorText = _.map(passwordInvalidReasons.args[0], function(passwordInvalidReason) {
        return $.i18n.prop(passwordInvalidReason.messageKey, passwordInvalidReason.params[0], passwordInvalidReason.params[1]);
      });
      return {
        text: errorText.join(' '),
        removeClass: 'brec-feedback--hidden',
        attr: ['aria-hidden', 'false']
      };
    },
    to: 'passwordError'
  }, {
    /**
    * On invalid password event, show error message
    * @property feedback[13] (Password Input Field) {When/Then Feedback}
    */
    when: {
      'on': ['invalidPassword']
    },
    then: function() {
      return {
        addClass: 'brec-form__input--error'
      };
    },
    to: 'newPassword'
  }, {
   //******** Confirm Password *********
   /**
    * On keyup or blur on the newPassword or confirmPassword or submits, validate the confirmPassword
    * @property feedback[14] (Confirm Password Error Message) {When/Then Feedback}
    */
   when: {
      '@newPassword' : ['keyup', 'blur', 'change'],
      '@confirmPassword' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
   then: function() {
      var isValid = this.model.isValid('confirmPassword');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('confirmPassword'), {
          'required.failed': 'patient.signup.confirmPassword.error.required',
          'error.match': 'patient.signup.confirmPassword.error.match'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'confirmPasswordError'
  }, {
    /**
    * On keyup or blur on the newPassword or confirmPassword or submits, validate the confirmPassword
    * @property feedback[15] (Confirm Password Input Field) {When/Then Feedback}
    */
    when: {
      '@newPassword' : ['keyup', 'blur', 'change'],
      '@confirmPassword' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('confirmPassword', 'brec-form__input--error');
    },
    to: 'confirmPassword'
  }, {
   /**
    * On keypress on the newPassword, check if the Capslock is on
    * @property feedback[16] (New Password Capslock On Warning) {When/Then Feedback}
    */
    when: {
      '@newPassword' : ['keypress']
    },
    then: function(event) {
      if (!capslockDetectorUtils.canCapsLockBeDetected(event)) {
        return;
      }
      if (capslockDetectorUtils.isCapsLockOn(event)) {
        return {
          removeClass: 'brec-hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'newPasswordCapslockOnWarning'
  }, {
   /**
    * On keypress on the confirmPassword, check if the Capslock is on
    * @property feedback[17] (Confirmed Password Capslock On Warning) {When/Then Feedback}
    */
    when: {
      '@confirmPassword' : ['keypress']
    },
    then: function(event) {
      if (!capslockDetectorUtils.canCapsLockBeDetected(event)) {
        return;
      }
      if (capslockDetectorUtils.isCapsLockOn(event)) {
        return {
          removeClass: 'brec-hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'confirmPasswordCapslockOnWarning'
  }, {
   //******** Email Address *********
   /**
    * On keyup or blur on the emailAddress or submits, validate the emailAddress
    * @property feedback[18] (Email Address Error Message) {When/Then Feedback}
    */
    when: {
      '@emailAddress' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('emailAddress');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('emailAddress'), {
          'required.failed': 'patient.signup.email.error.required',
          'error.invalid' : 'patient.signup.email.error.invalid'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'emailError'
  }, {
    /**
    * On keyup or blur on the emailAddress or submits, validate the emailAddress
    * @property feedback[19] (Email Address Input Field) {When/Then Feedback}
    */
    when: {
      '@emailAddress' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('emailAddress', 'brec-form__input--error');
    },
    to: 'emailAddress'
  }, {
   //******** Confirm Email Address *********
   /**
    * On keyup or blur on the confirmEmailAddress or submits, validate the confirmEmailAddress
    * @property feedback[20] (Confirm Email Address Error Message) {When/Then Feedback}
    */
    when: {
      '@emailAddress' : ['keyup', 'blur', 'change'],
      '@confirmEmailAddress' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('confirmEmailAddress');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('confirmEmailAddress'), {
          'required.failed': 'patient.signup.confirmEmail.error.required',
          'error.invalid' : 'patient.signup.confirmEmail.error.invalid',
          'error.match': 'patient.signup.confirmEmail.error.match'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'confirmEmailError'
  }, {
    /**
    * On keyup or blur on the confirmEmailAddress or submits, validate the confirmEmailAddress
    * @property feedback[21] (Confirm Email Address Input Field) {When/Then Feedback}
    */
    when: {
      '@emailAddress' : ['keyup', 'blur', 'change'],
      '@confirmEmailAddress' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('confirmEmailAddress', 'brec-form__input--error');
    },
    to: 'confirmEmailAddress'
  }, {
   //******** Security Question 1 *********
   /**
    * On keyup or blur on the securityQuestion1 or submits, validate the securityQuestion1
    * @property feedback[22] (Security Question 1 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityQuestion1' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('securityQuestion1');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityQuestion1Error'
  }, {
   /**
    * On keyup or blur on the securityQuestion1 or submits, validate the securityQuestion1
    * @property feedback[23] (Security Question 1 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityQuestion1' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityQuestion1', 'brec-form__input--error');
    },
    to: 'securityQuestion1'
  }, {
   //******** Security Answer 1 *********
   /**
    * On keyup or blur on the securityAnswer1 or submits, validate the securityAnswer1
    * @property feedback[24] (Security Answer 1 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityAnswer1' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('securityAnswer1');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityAnswer1Error'
  }, {
    /**
    * On keyup or blur on the securityAnswer1 or submits, validate the securityAnswer1
    * @property feedback[25] (Security Answer 1 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityAnswer1' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityAnswer1', 'brec-form__input--error');
    },
    to: 'securityAnswer1'
  }, {
   //******** Security Question 2 *********
   /**
    * On keyup or blur on the securityQuestion2 or submits, validate the securityQuestion2
    * @property feedback[26] (Security Question 2 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityQuestion2' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('securityQuestion2');
      if (!isValid) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('securityQuestion2'), {
          'required.failed': 'patient.signup.secuirtyQuestions.question.error.required',
          'error.unique' : 'patient.signup.secuirtyQuestions.question.error.unique'
        });
        var result = {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
        return _.extend(result, errorText);
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityQuestion2Error'
  }, {
    /**
    * On keyup or blur on the securityQuestion2 or submits, validate the securityQuestion2
    * @property feedback[27] (Security Question 2 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityQuestion2' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityQuestion2', 'brec-form__input--error');
    },
    to: 'securityQuestion2'
  }, {
   //******** Security Answer 2 *********
   /**
    * On keyup or blur on the securityAnswer2 or submits, validate the securityAnswer2
    * @property feedback[28] (Security Answer 2 Error Message) {When/Then Feedback}
    */
    when: {
      '@securityAnswer2' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('securityAnswer2');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'securityAnswer2Error'
  }, {
    /**
    * On keyup or blur on the securityAnswer2 or submits, validate the securityAnswer2
    * @property feedback[29] (Security Answer 2 Input Field) {When/Then Feedback}
    */
    when: {
      '@securityAnswer2' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      return this._thenAddClassIfInvalid('securityAnswer2', 'brec-form__input--error');
    },
    to: 'securityAnswer2'
  }, {
   //******** Additional Enrollment Form *********
   /**
    * On keyup or blur on the agreedToAdditionalForm or submits, validate the agreedToAdditionalForm
    * @property feedback[30] (Additional Enrollment Form Error Message) {When/Then Feedback}
    */
    when: {
      '@agreedToAdditionalForm' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('agreedToAdditionalForm');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'agreedToAdditionalFormError'
  }, {
   //******** Privacy Policy Form *********
   /**
    * On keyup or blur on the agreedToPrivacyForm or submits, validate the agreedToPrivacyForm
    * @property feedback[31] (Privacy Policy Form Error Message) {When/Then Feedback}
    */
    when: {
      '@agreedToPrivacyForm' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('agreedToPrivacyForm');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'agreedToPrivacyFormError'
  }, {
   //******** General Consent Form *********
   /**
    * On keyup or blur on the agreedToDisclaimer or submits, validate the agreedToDisclaimer
    * @property feedback[32] (General Consent Form Error Message) {When/Then Feedback}
    */
    when: {
      '@agreedToDisclaimer' : ['keyup', 'blur', 'change'],
      'on': ['validate']
    },
    then: function() {
      var isValid = this.model.isValid('agreedToDisclaimer');
      if (!isValid) {
        return {
          removeClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'false']
        };
      } else {
        return {
          addClass: 'brec-feedback--hidden',
          attr: ['aria-hidden', 'true']
        };
      }
    },
    to: 'agreedToDisclaimerError'
  }],

  /**
   * Map from error code to errors object to use.  If a function is defined then it will be
   * called in the context of this view.
   * @property _errorCodeMap
   * @type {Object}
   */
  _errorCodeMap: {
    404 : { errorCode: 'NOT_FOUND' },
    500 : { errorCode: 'INTERNAL_ERROR' },
    default : { errorCode: 'ERROR' }
  },

  /**
   * @method initialize
   * @param [options={}] {Object}
   *   @param [options.inviteId=undefined] {String} the invite id for the patient to signup.
   * @override
   */
  initialize: function(options) {
    options = options || {};
    var inviteId = options.inviteId;
    // Bind this context to methods used by promises
    _.bindAll(this, '_processErrors', 'render', '_formatSsn', '_setAuthenticated');
    this.model = new PatientSignupFormModel();
    this.model.set('inviteId', inviteId);
    this.model.set('authenticated', false);

    this.listenTo(this.viewState, 'change', this.render);
    var additionalEnrollmentFormDataBehavior = this.getBehavior('additionalEnrollmentForm');
    this.listenTo(additionalEnrollmentFormDataBehavior, 'fetched', this._setupAdditionalFormPdfViewer);
  },

  /**
   * Uses moment to convert the date string from the fromDateFormat pattern to the toDateFormat pattern.
   *
   * @method _convertDateToNewFormat
   * @param date {String} the date to convert.
   * @param fromDateFormat {String} pattern that moment should use for the incoming date.
   * @param toDateFormat {String} pattern that moment should use for the returned format.
   * @returns {String} the re-formatted date or '' if the date could not be formatted correctly.
   * @private
   */
  _convertDateToNewFormat: function(date, fromDateFormat, toDateFormat) {
    var momentDate = moment(date, fromDateFormat);
    if (date && momentDate.isValid()) {
      return momentDate.format(toDateFormat);
    } else {
      return '';
    }
  },

  /**
   * Submit the form
   * @param event {jQuery.Event} the click event that triggered this call.
   * @method _submit
   * @private
   */
  _submit: function(event) {
    var successUrl;
    if(event) {
      event.preventDefault();
     successUrl = $(event.currentTarget).attr('data-success-url');
    }
    this.unset('errors');
    this.trigger('validate');
    var validationErrors = this.model.validate();
    if (!validationErrors) {
      if (!this.model.get('authenticated')) {
        patientRegistrationService.authenticate(this.model)
          .then(this._setAuthenticated, this._processErrors);
      } else {
        var view = this;
        patientRegistrationService.signup(this.model)
          .then(function() {
            view._navigateToSuccessUrl(successUrl);
          }, this._processErrors);
      }
    }
  },

  /**
   * @method _setAuthenticated
   * @private
   */
  _setAuthenticated: function(response) {
    var vecnaId = response.vecnaId;
    this.model.set('vecnaId', vecnaId);
    this.model.set('authenticated', true);
    this._setupAdditionalFieldsForSignup();
  },

  /**
   * @method _setupAdditionalFieldsForSignup
   * @private
   */
  _setupAdditionalFieldsForSignup:function() {
    this._setupSecurityQuestions();
    this._setupEnrollmentForms();
  },

  /**
   * @method _setupSecurityQuestions
   * @private
   */
  _setupSecurityQuestions: function() {
    enumerationListService.fetch(SECURITY_QUESTIONS_OPTIONS_LIST);
  },

  /**
   * @method _setupEnrollmentForms
   * @private
   */
  _setupEnrollmentForms: function() {
    formFeatureConfigModel.loadOnce()
      .then(function() {
        this.model.setTrackedModel('formFeatureConfigModel', formFeatureConfigModel, true);
      }.bind(this));

    var privacyFormName = $.i18n.prop('patient.signup.privacy.policy.formName');
    this._privacyFormPdfViewer = new PdfViewerWidget({pdfUrl : formExtService + '/' + privacyFormName + '/pdf'});

    var consentFormName = $.i18n.prop('patient.signup.general.consent.formName');
    this._consentFormPdfViewer = new PdfViewerWidget({pdfUrl : formExtService + '/' + consentFormName + '/pdf'});
  },

  /**
   * @method _setupAdditionalFormPdfViewer
   * @private
   */
  _setupAdditionalFormPdfViewer: function() {
    var additionalFormBehavior = this.getBehavior('additionalEnrollmentForm').data;
    var formName = additionalFormBehavior.get('name');
    if (formName) {
      this._additionalFormPdfViewer = new PdfViewerWidget({pdfUrl : formExtService + '/' + formName + '/pdf'});
    }
    this.render();
  },

  /**
   * Sets the passed error onto the view state. The error code maps to i18n key as defined in the template. If the response contains
   * a message key for the error, that will be used instead of the mapped response status message.
   * Also clears any form data.
   *
   * @param response {Object} HTTP response
   * @private
   * @method _processErrors
   */
  _processErrors: function(response) {
    var responseStatus = response && response.status;
    var errors = this._errorCodeMap[responseStatus];
    if (_.isFunction(errors)) {
      var errorFn = _.bind(errors, this);
      errors = errorFn(response);
    }
    errors = errors || this._errorCodeMap.default;

    if (response && response.responseJSON && !_.isEmpty(response.responseJSON.generalReasons)) {
      var generalReason = response.responseJSON.generalReasons[0];
      errors.specificReasonKey = generalReason.messageKey;
    }

    if (response && response.responseJSON && !_.isEmpty(response.responseJSON.specificReasons)) {
       var passwordInvalidReasons = response.responseJSON.specificReasons.newPassword;
       this.trigger('invalidPassword', passwordInvalidReasons);
    }

    this.set('errors', errors);
  },

  /**
   * Navigate to the url after successfully signed up.
   *
   * @method _navigateToSuccessUrl
   * @private
   */
  _navigateToSuccessUrl: function(successUrl) {
    window.location.href = successUrl;
  },

  /**
   * Format the ssn on form model when user keyup from the ssn field
   * @param event {Event Object} the keyup event
   * @method _formatSsn
   * @private
   */
  _formatSsn: function(event) {
    if (event) {
      event.preventDefault();
    }
    this.model.formatSsn();
  },

  /**
   * @method _attached
   * @private
   */
  _attached: function() {
    this.listenTo(enumerationListService, 'change:' + SECURITY_QUESTIONS_OPTIONS_LIST, this.render);
    this.listenTo(formFeatureConfigModel, 'load-complete', this.render);
  },

  /**
   * @method _detached
   * @private
   */
  _detached: function() {
    this.stopListening(enumerationListService, 'change:' + SECURITY_QUESTIONS_OPTIONS_LIST, this.render);
    this.stopListening(formFeatureConfigModel, 'load-complete', this.render);
  }
});
